import { useQuery } from "@tanstack/react-query"
import { whatsappAccountAlertsQuery } from "../../lib/whatsapp/whatsappAccountAlertsQuery"

export function useWhatsappAccountAlertsQuery(
  ...args: Parameters<typeof whatsappAccountAlertsQuery>
) {
  return useQuery(whatsappAccountAlertsQuery(...args))
}
